import { breakpointAtLeast } from '../utils.js';

(function ($) {
  /* Tabs in single bonds & projects archive */
  $('.js-tab-btn').on('click', function (e) {
    e.preventDefault();
    $(this)
      .closest('.js-tab-btn-wrapper')
      .find('.is-active')
      .removeClass('is-active');
    $(this).addClass('is-active');

    var tabs = $(this).closest('.js-tabs').find('.js-tab-content');
    tabs.removeClass('is-active');

    // Find tab ID via data-tab attribute
    var $current_tab = $(this)
      .closest('.js-tabs')
      .find('#' + $(this).data('tab'));
    $current_tab.addClass('is-active');
  });

  // Check if tab should be active via hash in url
  // To avoid autoscroll to anchor, hash should be: #tab-list or #tab-map
  // Fallback to default behaviour
  var hash = window.location.hash;
  if (hash) {
    var strip_hash = hash.replace('tab-', '');
    var $current_tab = $('.js-tabs').find(strip_hash);
    if ($current_tab.length > 0) {
      $('.js-tab-btn[data-tab="' + strip_hash.replace('#', '') + '"]').trigger(
        'click',
      );
    } else {
      setDefaultTab();
    }
  } else {
    setDefaultTab();
  }

  function setDefaultTab() {
    // Adjust behaviour in Projects archive tabs
    // Set "map" tab as active by default on medium screens up
    if (breakpointAtLeast('medium')) {
      $('.js-tab-btn[data-tab="list"]').trigger('click');
    } else {
      $('.js-tab-btn[data-tab="list"]').trigger('click');
    }
  }
})(jQuery);
